export function CheckIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.833008 4.64229L3.8336 8.12297L9.53471 1.50968"
        stroke="currentcolor"
        strokeWidth="1.25"
      />
    </svg>
  );
}
